import { createFileRoute } from '@tanstack/react-router';
import { PlannerPlaceholder } from '../components/PlannerPlaceholder.js';

export const Route = createFileRoute('/_planner/cart')({
  component: () => <PlannerPlaceholder id="cart" />,
});
